import { render, staticRenderFns } from "./SaleIn.vue?vue&type=template&id=2444b086&scoped=true"
import script from "./SaleIn.vue?vue&type=script&lang=js"
export * from "./SaleIn.vue?vue&type=script&lang=js"
import style0 from "./SaleIn.vue?vue&type=style&index=0&id=2444b086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2444b086",
  null
  
)

export default component.exports